import React from 'react'
import styled, { css } from 'styled-components'
import { mobile } from '../../utils/media'
import { isDarkMode } from '../../utils/util'
// import ColumnContent from '../../views/Columns/ColumnsContent'

import Footer from '../Footer'
// import TopBar from '../TopBar'

type PageProps = {
  children: React.ReactNode;
  showTopBar?: boolean;
}

const Page: React.FC<PageProps> = ({ children,showTopBar=true }) => (
  <StyledPage>
    {/* {showTopBar&&<TopBar />} */}
    {/* <ColumnContent/> */}
    <StyledMain>
      {children}
    </StyledMain>
    {/* <Footer /> */}
  </StyledPage>
)

const StyledPage = styled.div`
  background-color: ${_=> isDarkMode()?  'black':'#f9f9f9'};
  ${mobile(css`
    background-color: ${_=> isDarkMode()?  'black':'#f9f9f9'};
  `)}
  vertical-align: middle;
  display: flex; 
  align-items: flex-start;
  justify-content: center;
  position: relative; 
  min-height: ${props=>document.body.clientHeight}px;
`

const StyledMain = styled.div`
  align-items: center;
  /* align-self: stretch; */
  
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - ${props => props.theme.topBarSize * 2}px);
  max-width: ${props => props.theme.siteWidth}px;
  width: 100%;
  
  /* padding-bottom: ${props => props.theme.spacing[5]}px; */
`

export default Page